import api from "@/services/api";

const { get, post, put, delete: del } = api.getPrefixedMethods("users");

export default {
  listUsers() {
    return get("");
  },
  listTeammates() {
    return get("teammates");
  },
  inviteUser(email) {
    return post("invite", { email });
  },
  // Provider invites (LAM-5263, LAM-6011): NPPES preview for the confirm step, then the prescriber and office staff.
  lookupProviderInvite(npi) {
    return get("provider-invite/registry", { params: { npi } });
  },
  inviteProvider({ npi, email, firstName, lastName, fax, officeEmails }) {
    return post("provider-invite", { npi, email, firstName, lastName, fax, officeEmails });
  },
  // Registered provider login for an NPI (LAM-5508): the channel and contact a send would actually use.
  lookupProviderAccount(npi) {
    return get("provider-account", { params: { npi } });
  },
  revokeInvite(pk) {
    return del(`${pk}`);
  },
  getUserActionNeeded(pk) {
    return get(`${pk}/action-needed`);
  },
  updateUserActionNeeded(pk, scope, statuses) {
    return put(`${pk}/action-needed`, { scope, statuses });
  },
  updateUserActionNeededLock(pk, locked) {
    return put(`${pk}/action-needed`, { locked });
  },
  updateUserAssignedOnly(pk, restricted) {
    return put(`${pk}/assigned-only`, { restricted });
  },
  deleteUser(pk) {
    return del(`${pk}`);
  },
  getGrantableCompanies() {
    return get("grantable-companies");
  },
  getUserCompanies(pk) {
    return get(`${pk}/companies`);
  },
  updateUserCompanies(pk, companyIds) {
    return put(`${pk}/companies`, { companyIds });
  },
};
